export var EVENTS = {
	RECORD_SELECTED: 'RECORD_SELECTED',
	NEW_RECORD: 'NEW_RECORD',
	SELECT_RECORD: 'SELECT_RECORD',
	SORT: 'SORT',
	DUPLICATES_RECORD_SELECTED: 'DUPLICATES_RECORD_SELECTED'
}